import React from "react";
import { Link } from "react-router-dom";
import Fade from "react-reveal/Fade";
import BannerImage from "./BannerImage";
import Buttons from "./Buttons";
import "../App.css";

// Fill in the Mac App Store link once the app is live.
const links = { mac: "" };

const features = [
  {
    image: require("../assets/img/fd/01-folder-audit.jpg"),
    title: "Spot the clips that don't match",
    desc: "Check a whole shoot folder in seconds",
    dl: "Drop in a folder and Footage Doctor checks every clip, finds the format most of them share, and highlights the ones that differ before they break your timeline.",
  },
  {
    image: require("../assets/img/fd/02-diagnosis.jpg"),
    title: "Plain English, not a spec sheet",
    desc: "Know what's wrong and what to do about it",
    dl: "Instead of raw technical fields, you get clear verdicts like \"this file will drift out of sync when you edit it\", with a recommended fix.",
  },
  {
    image: require("../assets/img/fd/03-compare.jpg"),
    title: "See exactly what changed",
    desc: "Compare two versions side by side",
    dl: "Put two exports next to each other and get one sentence that explains the difference, with matching thumbnails and a table of what matters.",
  },
  {
    image: require("../assets/img/fd/04-damaged-frames.jpg"),
    title: "Catch damaged files that still open",
    desc: "Frames are decoded, not just headers",
    dl: "Footage Doctor decodes sample frames, so blank or broken video is caught even when the file opens and looks fine at a glance.",
  },
  {
    image: require("../assets/img/fd/05-playback.jpg"),
    title: "Know if it plays on your Mac",
    desc: "Checked against this Mac, not a codec chart",
    dl: "Footage Doctor asks macOS what this Mac can play and decode in hardware, and tells you when a file needs converting.",
  },
  {
    image: require("../assets/img/fd/06-technical-details.jpg"),
    title: "Every detail, when you want it",
    desc: "Full technical breakdown right below the verdicts",
    dl: "Codec, resolution, frame rate, bit depth, colour and audio are all there when you need to dig in, plus JSON or CSV reports when you need to share.",
  },
];

const section = { maxWidth: "1100px", margin: "0 auto", padding: "0 20px" };
const featureTitle = { fontSize: "24px", margin: "0 0 6px" };
const featureDesc = { margin: "0 0 10px", fontSize: "15px", color: "#555" };

const FeatureRow = ({ feature, imageFirst }) => {
  const image = (
    <div className="nine wide column">
      <img
        src={feature.image}
        alt={feature.title}
        className="ui fluid rounded image"
        style={{ boxShadow: "0 8px 24px rgba(0, 0, 0, 0.25)" }}
      />
    </div>
  );
  const text = (
    <div className="seven wide middle aligned column">
      <h3 style={featureTitle}>{feature.title}</h3>
      <h5 style={featureDesc}>{feature.desc}</h5>
      <p>{feature.dl}</p>
    </div>
  );

  return (
    <Fade left={imageFirst} right={!imageFirst} fraction={0.2} duration={1200} distance={"80px"}>
      <div className="ui stackable grid" style={section}>
        <div className="row">
          {imageFirst ? (
            <>
              {image}
              {text}
            </>
          ) : (
            <>
              {text}
              {image}
            </>
          )}
        </div>
      </div>
    </Fade>
  );
};

const FootageDoctor = () => {
  document.title = "Footage Doctor";

  return (
    <div className="ui">
      <BannerImage
        title={"Footage Doctor"}
        image={require("../assets/img/fd/01-folder-audit.jpg")}
      />

      <div className="marginTopBtm" style={{ ...section, textAlign: "center" }}>
        <img
          src={require("../assets/img/fd/icon.png")}
          alt="Footage Doctor app icon"
          width="128"
        />
        <h2 style={{ margin: "10px 0" }}>Check footage before you edit</h2>
        <p style={{ fontSize: "17px", maxWidth: "640px", margin: "0 auto 20px" }}>
          Footage Doctor is a quality-control checker for video and audio on your
          Mac. Drop in a clip or a whole folder and get plain-language verdicts on
          whether it's fit to edit, upload or archive.
        </p>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Buttons links={links} />
        </div>
      </div>

      {features.map((feature, i) => (
        <div
          key={feature.title}
          className={i % 2 === 0 ? "altColor marginTopBtm" : "marginTopBtm"}
        >
          <FeatureRow feature={feature} imageFirst={i % 2 === 0} />
        </div>
      ))}

      <div className="marginTopBtm" style={section}>
        <h2 id="privacy">Privacy</h2>
        <p>
          Footage Doctor doesn't collect any data. It has no account, no
          analytics and no network access. Your files are read on your Mac and
          never changed or uploaded, and your list of recent checks stays on
          your Mac until you clear it.{" "}
          <Link to="/footagedoctor/privacy">Read the full privacy policy</Link>.
        </p>

        <h2 id="support">Support</h2>
        <p>
          Questions, bug reports or feature requests? Email{" "}
          <a href="mailto:joabchua@gmail.com?subject=Footage%20Doctor">
            joabchua@gmail.com
          </a>
          . Please include your macOS version and, if you can, the type of file
          you were checking.
        </p>
        <div className="ui list">
          <div className="item">
            <strong>Requirements:</strong> macOS 14 Sonoma or later, on Apple
            silicon or Intel.
          </div>
          <div className="item">
            <strong>Formats:</strong> MP4, MOV, MKV, WebM, MXF, AVI, MPEG-TS and
            common audio files.
          </div>
        </div>
      </div>
    </div>
  );
};

export default FootageDoctor;
